<template>
  <!-- <AddButton btnname="Add New" class=" float-rights " v-if="showButton" @click="IsCreate()">
        Add New
    </AddButton>
    <EditIcon v-if="!showButton" @click="IsEditpop()">Edit</EditIcon> -->
  <Dialog
    v-model:visible="showDialog"
    :modal="true"
    :header="model ? $t('Payment.Edittitle') : $t('Payment.title')"
    :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
    :style="{ width: '40vw' }"
    @after-hide="IsClear"
  >
    <b-form @submit.prevent="IsSubmit">
      <b-row>
        <b-col sm="6">
          <div class="field">
            <TextField
              id="code"
              name="code"
              :label="$t('Payment.code')"
              :rules="{ required: true }"
              :disabled="true"
              v-model="paymentTermsform.PaymentTermsCode"
              placeholder=" "
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="6">
          <div class="field">
            <TextField
              id="Days"
              name="Days"
              :label="$t('Payment.days')"
              :rules="{ required: true, numeric: true, nonzeroable: true }"
              :requiredIcon="true"
              v-model="paymentTermsform.NoofDays"
              placeholder=" "
              :autofocus="true"
            />
          </div>
        </b-col>
        <b-col sm="6">
          <div class="field">
            <TextField
              id="Advance"
              name="Advance"
              :label="$t('Payment.advance')"
              :rules="{
                required: true,
                decimal: true,
                nonzeroable: true,
                percentage: true,
              }"
              :requiredIcon="true"
              v-model="paymentTermsform.PercentageOfAdvance"
              placeholder=" "
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="field">
            <Textarea
              id="Remark"
              name="Remark"
              :label="$t('Payment.remark')"
              :rules="{ required: false }"
              v-model="paymentTermsform.PaymentTermsDesc"
              placeholder=" "
              :requiredIcon="false"
            />
          </div>
        </b-col>
      </b-row>
      <Footer
        @cancel="(showDialog = false), IsClear()"
        :cancelhide="false"
        :label="label"
        :loading="Saveloading"
      />
    </b-form>
  </Dialog>
  <CreateSuccessully :visible="successpop" @ok="closetrigger()" />
  <EditConfirmation
    :Editmodel="Editmodel"
    @yes="IsEdit()"
    @no="Editmodel = false"
    :content="$t('confirmation.editcontent')"
  />
  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
  <Toast />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";

import Footer from "../../../../../../components/FormComponents/Footer.vue";
import PaymentTermsService from "../../../../../../modules/Inventory/Service/PaymentTermsService";
import TextField from "../../../../../../components/FormComponents/TextInput.vue";
import NumberField from "../../../../../../components/FormComponents/InputNumber.vue";
import common from "../../../../Service/CommonService";
import Textarea from "../../../../../../components/FormComponents/TextArea.vue";
import { useForm } from "vee-validate";
import { useI18n } from "vue-i18n";
import CreateSuccessully from "../../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import EditConfirmation from "../../../../../../components/FormComponents/EditConfirmation.vue";
import { useToast } from "primevue/usetoast";
import moment from "moment";

export default defineComponent({
  props: {
    trigger: {
      readonly: false,
      type: Boolean,
      default: ref(false),
    },
    selectedItem: {
      type: Object,
      Default: () => {},
    },
    showButton: {
      type: Boolean,
      Required: true,
    },
    OperationID: {
      type: Object,
      default: {},
    },
    EntityId: {
      type: Number,
      default: 0,
    },
  },
  components: {
    CreateSuccessully,
    UpdatedSuccessfully,
    EditConfirmation,

    Footer,
    TextField,
    Textarea,
    NumberField,
  },
  setup(props, { emit }) {
    let session: any = localStorage.getItem("UsersData");
    let Saveloading = ref(false);
    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);
    // let Entitydata = ref();
    // Entitydata.value = localStorage.getItem("EntityData");
    // Entitydata.value = JSON.parse(Entitydata.value);
    let Entitydata = ref({
      EntityId: 0,
    });
    Entitydata.value.EntityId = props.EntityId;
    const successpop = ref(false);
    const updatepop = ref(false);
    const Editmodel = ref(false);
    const { t } = useI18n();
    const { handleSubmit, errors, resetForm, resetField, validate } = useForm();
    const showDialog = ref();
    const model: any = ref(props.selectedItem);
    const toast = useToast();
    const label = ref(t("btn.save"));
    //update and create jsonrequest

    const paymentTermsform = ref({
      CreatedAt: "",
      CreatedBy: 0,
      ModifiedBy: 0,
      ModifiedAt: "",
      HospitalId: 0,
      BranchId: 0,
      Id: 0,
      PaymentTermsCode: "",
      PaymentTermsDesc: "",

      NoofDays: "",
      PercentageOfAdvance: "",
      EntityId: 0,
      EntityOperationId: 0,
    });

    //findone function
    const IsEdit = async () => {
      try {
        showDialog.value = true;
        emit("loadershow");
        label.value = "Update";
        let Id = model.value.Id;
        const response = await PaymentTermsService.getfindonedata(Id);

        let data = response["result"];
        Object.keys(paymentTermsform.value).forEach((key) => {
          if (data[key]) paymentTermsform.value[key] = data[key];
        });
        Editmodel.value = false;
        emit("loaderhide");

        console.log(response);
      } catch (error) {
        alert(error);
      }
      emit("show");
    };
    if (model.value != null) {
      IsEdit();
    } else {
      IsCreate();
    }
    function IsCreate() {
      showDialog.value = true;
      GetCode();
    }
    async function GetCode() {
      debugger;
      let data = {
        // FormId: 10,
        EntityId: Entitydata.value.EntityId,
        HospitalId: HospitalId,
        BranchId: BranchId,
        StoreId: 0,
      };
      let result: any = await common.getCodeTemplate(data);
      console.log(result);

      paymentTermsform.value.PaymentTermsCode = result;
    }
    onMounted(() => {
      debugger;
      document.addEventListener("keydown", onKeyUp);
    });
    let isSubmitCalled = false;
    function onKeyUp(event: KeyboardEvent) {
      debugger;

      if (event.altKey && event.key == "s") {
        if (!isSubmitCalled) {
          isSubmitCalled = true;
          IsSubmit();
        }
      } else if (
        (event.altKey && event.key == "c") ||
        (event.key == "Escape" &&
          successpop.value == false &&
          updatepop.value == false)
      ) {
        IsClear();
      }
      // else if (event.altKey && event.key == 'n') {
      // showDialog.value = true;
      // }
      else if (
        event.key == "Escape" &&
        (successpop.value == true || updatepop.value == true)
      ) {
        closetrigger();
      }
      // else if (event.key == 'e') {
      // IsEdit()
      // }
      // else if (event.key == 'Escape') {

      // IsClear()
      // }
    }

    //update and create function
    const IsSubmit = async () => {
      Saveloading.value = true;

      // Run validation on all fields
      const results = await validate();

      if (!results.valid) {
        const form = document.querySelector("form");
        const allFormFields: any = form?.querySelectorAll("[id]");
        console.log("All form fields:", allFormFields);

        const errorFields = Object.keys(results.errors);
        const firstErrorField = errorFields[0];
        console.log("First error:", firstErrorField);

        for (const field of allFormFields) {
          console.log("Checking field:", field.id);
          if (field.id === firstErrorField) {
            const component = field.closest(".field");

            if (!component) continue;

            if (component.querySelector(".p-calendar")) {
              const calendar = component.querySelector(".p-calendar input");
              if (calendar) {
                calendar.focus();
                calendar.click();
              }
            } else if (component.querySelector(".p-dropdown")) {
              const dropdown = component.querySelector(".p-dropdown");
              if (dropdown) {
                dropdown.click();
                dropdown.querySelector(".p-dropdown-trigger")?.click();
              }
            } else if (component.querySelector(".p-multiselect")) {
              const multiselect = component.querySelector(".p-multiselect");
              if (multiselect) {
                multiselect.click();
                multiselect.querySelector(".p-multiselect-trigger")?.click();
              }
            } else if (component.querySelector(".p-autocomplete")) {
              const autocomplete = component.querySelector(
                ".p-autocomplete input"
              );
              if (autocomplete) {
                autocomplete.focus();
                autocomplete.click();
              }
            } else {
              const input = component.querySelector("input, textarea");
              if (input) {
                input.focus();
                if (
                  input.type === "text" ||
                  input.type === "email" ||
                  input.tagName.toLowerCase() === "textarea"
                ) {
                  input.select();
                }
              }
            }

            component.scrollIntoView({ behavior: "smooth", block: "center" });
            break;
          }
        }

        Saveloading.value = false;
        return;
      }

      try {
        emit("loadershow");
        paymentTermsform.value.CreatedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );
        paymentTermsform.value.ModifiedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );
        paymentTermsform.value.BranchId = 0;
        paymentTermsform.value.HospitalId = HospitalId;
        paymentTermsform.value.ModifiedBy = UserId;
        paymentTermsform.value.CreatedBy = UserId;
        paymentTermsform.value.EntityId = Number(Entitydata.value.EntityId);
        if (paymentTermsform.value.Id != 0) {
          paymentTermsform.value.EntityOperationId = props.OperationID.UpdateId;

          const response = await PaymentTermsService.updatedata(
            paymentTermsform.value
          );
          let message = response["ErrorInfo"].ErrorCode;
          emit("loaderhide");

          if (message == null) {
            Saveloading.value = false;
            showDialog.value = true;
            updatepop.value = true;
          }
        } else {
          paymentTermsform.value.EntityOperationId = props.OperationID.CreateId;

          const response = await PaymentTermsService.createdata(
            paymentTermsform.value
          );
          let message = response["ErrorInfo"].ErrorCode;
          emit("loaderhide");

          if (message == null) {
            // showDialog.value = false;
            Saveloading.value = false;
            successpop.value = true;
          }
        }
      } catch (error) {
        alert(error);
        Saveloading.value = false;
      }
    };
    // IsClear data function
    const IsClear = () => {
      paymentTermsform.value.Id = 0;
      paymentTermsform.value.PaymentTermsDesc = "";
      paymentTermsform.value.PaymentTermsCode = "";
      paymentTermsform.value.NoofDays = "";
      paymentTermsform.value.PercentageOfAdvance = "";
      emit("update:selectedItem", undefined);
      emit("close");
    };
    //popup create

    async function IsEditpop() {
      Editmodel.value = true;
    }
    //Created Sucessfully Popup-Close
    function closetrigger() {
      IsClear();
      emit("load");
      successpop.value = false;
      updatepop.value = false;
    }
    return {
      Saveloading,
      IsEditpop,
      closetrigger,
      Editmodel,
      updatepop,
      successpop,
      showDialog,
      IsCreate,
      IsClear,
      IsEdit,
      paymentTermsform,
      IsSubmit,
      label,
      model,
    };
  },
});
</script>
